<template>
    <v-btn
        class="text-none habiteo-body-2 mx-2 text-btn"
        :class="{
            'small-btn': isSmall,
            'medium-btn': isMedium
        }"
        outlined
        :ripple="false"
        @click.prevent="manageClick"
    >
        <span>
            {{ text }}
        </span>
    </v-btn>
</template>

<script>
    export default {
        name: "TextButton",
        props: {
            text: {
                type: String,
                required: true
            },
            isSmall: {
                type: Boolean,
                required: true
            },
            isMedium: {
                type: Boolean,
                required: true
            }
        },
        methods: {
            manageClick() {
                this.$emit('manage-click');
            }
        }
    }
</script>

<style lang="scss" scoped>
    button.v-btn {
        &.small-btn {
            letter-spacing: 0;
            width: 125px;
        }

        &.medium-btn {
            width: 134px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/searchPopup/components/TextButton.vue